<script>
import { mapGetters } from 'vuex';
import SignupForm from './components/Signup/Form.vue';
import Testimonials from '../../../../../v3/views/auth/signup/components/Testimonials/Index.vue';
import Spinner from 'shared/components/Spinner.vue';
import GapifyHeader from '../AuthHeader.vue';
import AuthLayout from '../AuthLayout.vue';
import OnboardingMotionSignup from './components/OnboardingMotionSignup.vue';
import { BaseButton } from '../../components/Button';

export default {
  components: {
    BaseButton,
    GapifyHeader,
    SignupForm,
    Spinner,
    Testimonials,
    AuthLayout,
    OnboardingMotionSignup,
  },
  data() {
    return { isLoading: false };
  },
  computed: {
    ...mapGetters({ globalConfig: 'globalConfig/get' }),
    isAChatwootInstance() {
      return this.globalConfig.installationName === 'Chatwoot';
    },
  },
  beforeMount() {
    this.isLoading = this.isAChatwootInstance;
  },
  methods: {
    resizeContainers() {
      this.isLoading = false;
    },
  },
};
</script>

<template>
  <AuthLayout>
    <template #left>
      <div
        v-show="!isLoading"
        class="flex flex-col w-full h-full min-[1440px]:justify-start justify-between px-4 min-[1440px]:px-10 min-[960px]:px-8 min-[1440px]:py-10 min-[960px]:pt-8 dark:bg-slate-900"
      >
        <div
          class="flex flex-col w-full h-full justify-between min-[1440px]:justify-start"
        >
          <GapifyHeader
            show-description
            :description="$t('REGISTER.HAVE_AN_ACCOUNT')"
            :title-text="$t('REGISTER.TRY_WOOT')"
            description-class="mt-5 !text-3 text-center !text-descriptionText dark:text-slate-400"
          >
            <template #description>
              <div
                class="flex flex-col min-[960px]:flex-row text-descriptionText dark:text-slate-300 text-[14px] min-[1440px]:text-[16px] gap-0 items-center"
              >
                <div class="flex">{{ $t('REGISTER.HAVE_AN_ACCOUNT') }}</div>
                <BaseButton
                  type="Text"
                  size="Small"
                  :text="$t('REGISTER.TO_LOGIN')"
                  class="!px-3"
                  @click="$router.push({ path: '/app/login' })"
                />
              </div>
            </template>
          </GapifyHeader>
          <SignupForm autocomplete="on" />
          <Testimonials
            v-if="isAChatwootInstance"
            class="flex-1"
            @resize-containers="resizeContainers"
          />
        </div>
      </div>
      <div
        v-show="isLoading"
        class="flex items-center justify-center w-full h-full"
      >
        <Spinner color-scheme="primary" size="" />
      </div>
    </template>
    <template #right>
      <OnboardingMotionSignup />
    </template>
  </AuthLayout>
</template>
